import * as tslib_1 from "tslib";
import cx from 'classnames';
import React from 'react';
import Styles from "./DataTableAction.css"; // TODO: refactor in crm-datatable

function DataTableAction(props) {
  var children = props.children,
      color = props.color,
      className = props.className,
      onClick = props.onClick,
      restChildProps = tslib_1.__rest(props, ["children", "color", "className", "onClick"]);

  return React.createElement("div", tslib_1.__assign({
    className: cx(className, Styles.action, color === 'red' && Styles.red),
    onClick: onClick
  }, restChildProps), children);
} //@ts-ignore until typings in place


export default React.memo(DataTableAction);